<template>
  <div class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-2">
    <label :for="uniqueId" class="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">
      {{ fieldLabel }}
    </label>
    <div class="mt-2 sm:col-span-2 sm:mt-0">
      <input
        :placeholder="$gettext('Entrer une adresse')"
        data-1p-ignore
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        v-bind="fieldAttrs"
        type="text"
        :name="fieldPath"
        :id="uniqueId"
        class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:max-w-xs sm:text-sm/6 invalid:outline-red-600 invalid:focus:outline-red-600"
      />
      <p v-if="errors[fieldPath]" class="text-sm text-red-600">{{ errors[fieldPath] }}</p>
    </div>
  </div>
</template>

<script setup>
import { Loader } from "@googlemaps/js-api-loader";
import { onMounted, ref } from "vue";

const props = defineProps(["modelValue", "fieldPath", "fieldAttrs", "fieldLabel", "errors"]);
const emit = defineEmits(["update:modelValue", "update:address"]);

const uniqueId = ref(`${props.fieldPath}-${Math.random().toString(36).slice(2, 11)}`);

onMounted(async () => {
  const loader = new Loader({
    apiKey: import.meta.env.VITE_APP_GOOGLE_MAPS_API_KEY,
    version: "weekly",
  });
  const Places = await loader.importLibrary("places");

  const input = document.getElementById(uniqueId.value);
  const options = {
    fields: ["address_components", "geometry", "icon", "name"],
  };

  const autocomplete = new Places.Autocomplete(input, options);
  autocomplete.addListener("place_changed", () => {
    const place = autocomplete.getPlace();
    emit("update:address", place);
  });
});
</script>
